<template>
  <router-view />
</template>

<script>
export default {
  mounted () {
    console.log('Bank View');
  },
}
</script>

<style scoped>

</style>
